'use client';
import styled, { css } from 'styled-components';

/**
 * Slot sizing: at least 1/N of the row so at most N items fit; content can
 * grow up to 100% and wrap. flex-shrink is 0 so items wrap instead of squashing.
 * The slot also gives nested CtaButton a definite cell to align within.
 */
const columnSizing = (columns, gapSpacing, minWidthPx) => css`
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
  min-width: min(
    100%,
    max(
      ${minWidthPx}px,
      calc((100% - (${columns} - 1) * ${gapSpacing}) / ${columns})
    )
  );
`;

const stretchFullWidth = css`
  flex: 1 1 100%;
  width: 100%;
  min-width: 0;
  max-width: 100%;

  & > * {
    width: 100%;
    max-width: 100%;
  }
`;

export const StyledCTAGroupComponent = styled.div`
  margin: ${props => props.theme.spacing(4, 0)};
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  gap: ${props => props.theme.spacing(props.$gap ? props.$gap : 4)};
`;

export const CTAButtonWrapper = styled.div`
  ${props => props.theme.getFocusOutline()};
  box-sizing: border-box;

  /* Fill the slot so nested CtaButton alignment can pack within the cell. */
  & > * {
    width: 100%;
    max-width: 100%;
  }

  ${props =>
    props.$fullWidthMobile
      ? stretchFullWidth
      : columnSizing(
          props.$buttonsPerRowMobile || 1,
          props.theme.spacing(props.$gap ? props.$gap : 4),
          props.$minWidth || 240,
        )}

  @media ${props => props.theme.tablet} {
    ${props =>
      props.$fullWidthDesktop
        ? stretchFullWidth
        : columnSizing(
            props.$buttonsPerRow || 2,
            props.theme.spacing(props.$gap ? props.$gap : 4),
            props.$minWidth || 240,
          )}
  }
`;
